import { render, staticRenderFns } from "./CatalogTabs.vue?vue&type=template&id=a7610340&lang=pug&"
import script from "./CatalogTabs.vue?vue&type=script&lang=js&"
export * from "./CatalogTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CatalogTabs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports